import { inject, Injectable } from '@angular/core'
import {
  API_CONFIGURATION,
  ApiClient,
  ApiClientType,
  ApiErrorMapper,
  FullApiClientConfiguration,
  HttpClientRemoteData,
} from '@ftr/api-shared'
import { CourtSystemRegionCache } from '@ftr/data-court-system'
import { collect } from '@ftr/foundation'
import { from, Observable } from 'rxjs'

/**
 * Create a client service for ftr-regional-audit (API) for a given controller path and a courtSystemId or region
 */
@Injectable({
  providedIn: 'root',
})
export class AuditApiClientFactory {
  private readonly http = inject(HttpClientRemoteData)
  private readonly configurationService = inject<FullApiClientConfiguration>(API_CONFIGURATION)
  private readonly apiErrorMapper = inject(ApiErrorMapper)
  private readonly courtSystemRegionCache = inject(CourtSystemRegionCache)

  build(path: string, courtSystemId: string, httpService: HttpClientRemoteData = this.http): Observable<ApiClient> {
    const courtSystem$ = this.courtSystemRegionCache.getOrFetchCourtSystem(from([courtSystemId]))

    return courtSystem$.pipe(collect(courtSystem => this.buildForRegion(path, courtSystem.region, httpService)))
  }

  buildForRegion(path: string, region: string, httpService: HttpClientRemoteData = this.http): ApiClient {
    return new ApiClient(
      httpService,
      this.configurationService,
      this.apiErrorMapper,
      { clientType: ApiClientType.audit, region },
      `/${path.replace(/^\//, '')}`,
    )
  }
}
